export default "__VITE_ASSET__c56c0613__"